import xxinyun from './xxinyun'
import birthPhoto from './birthPhoto'
import retro from './retro'
import lolita from './lolita'
import lolita2022 from './lolita2022'
import parentChildPhoto from './parentChildPhoto'
import guofeng from './guofeng'
import firstLook from './firstLook'
import zjz from './zjz'
import withYou from './withYou'
import autumnFlower from './autumnFlower'
import petsShopLab from './petsShopLab'
import birthday from './birthday'
import aotiShopLabxx from './aotiShopLabxx'
import masterPortrait from './masterPortrait'
import y2k from './y2k'

import weddingDressCooperation20220409 from './weddingDressCooperation20220409'
import weddingDress20220409 from './weddingDress20220409'
import supersenseGarden from './supersenseGarden'
import chinaHimo from './chinaHimo'
import literature2022 from './literature2022'
import rhythm from './rhythm'
import guofeng2022 from './guofeng2022'
import theGirl2022 from './theGirl2022'
import shopLabFeature from './shopLabFeature'
import shopLabPhoto from './shopLabPhoto'
import marriage2022 from './marriage2022'
import familyGy from './familyGy'
import familyMotion from './familyMotion'
import sunnySmile from './sunnySmile'
import autumnFlower2022 from './autumnFlower2022'
import girlDream from './girlDream2022'
import ctJointly from './ctJointly'
import yunfuMaster2022 from './yunfuMaster2022'
import birthday2022 from './birthday2022'
import guochao from './guochao'
import petsShopLab2022 from './petsShopLab2022'
import filmstrip from './filmstrip'
import garden from './garden'
import trueLove2022 from './trueLove2022'
import ImageArt2022 from './ImageArt2022'
export default {
  trueLove2022,
  garden,
  ctJointly,
  xxinyun,
  birthPhoto,
  retro,
  lolita,
  lolita2022,
  parentChildPhoto,
  guofeng,
  firstLook,
  zjz,
  withYou,
  autumnFlower,
  petsShopLab,
  birthday,
  aotiShopLabxx,
  masterPortrait,
  y2k,
  weddingDress20220409,
  weddingDressCooperation20220409,
  supersenseGarden,
  chinaHimo,
  literature2022,
  rhythm,
  guofeng2022,
  theGirl2022,
  shopLabFeature,
  shopLabPhoto,
  marriage2022,
  familyGy,
  familyMotion,
  sunnySmile,
  autumnFlower2022,
  girlDream,
  yunfuMaster2022,
  birthday2022,
  guochao,
  petsShopLab2022,
  filmstrip,
  ImageArt2022
}
